<script setup>
import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";

defineProps({
    religions: Array
});
const rutaprefijo = ref('religion');
const modulo = ref('religión');
</script>

<template>
    <Head title="Religiones Config." />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Religiones" />
        </template>


        <div class="py-8 lg:py-10">
            <div class="mx-auto sm:px-6 lg:px-8 px-4">
                <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                    <CardBox class="mb-6" has-table>
                        <!-- Tablesingle opciones: checkable -->
                        <TableSingle :modulo="modulo" :data="religions" :ruta="rutaprefijo" />
                    </CardBox>

                </div>
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>
